import React, { PureComponent } from 'react';

import { ButtonIcon } from 'components/button';
import { DatePicker } from 'components/date';
import { Dropdown, DropdownItem } from 'components/dropdown';
import { InfoTooltip } from 'components/tooltip';
import { I18n } from 'components/translate';
import DateHelper, { shortFormatDate } from 'helpers/Date';
import { UiService } from 'modules/ui';
import { UserManagerService } from 'modules/userManager';
import PropTypes from 'prop-types';

import { MAX_INFORMATION_LENGTH } from '../constants';

import './DetailBoard.scss';

export default class DetailBoard extends PureComponent {
  constructor(props) {
    super(props);

    this.updatePurchaseDate = this.updatePurchaseDate.bind(this);

    this.state = {
      information: props.information,
      editMode: false
    };

    if (props.useInput) {
      DateHelper.setMomentLocale();
    }
  }

  static propTypes = {
    title: PropTypes.string,
    information: PropTypes.string,
    useInput: PropTypes.bool,
    userAreaHash: PropTypes.string,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func,
        id: PropTypes.string,
        icon: PropTypes.string
      })
    )
  };

  static defaultProps = {
    useInput: false,
    actions: []
  };

  async updatePurchaseDate() {
    const { userAreaHash } = this.props;
    const { information } = this.state;

    try {
      const date = DateHelper.unixTimeToISOString(information);

      await UserManagerService.updatePurchaseDate(userAreaHash, date);
      UiService.setAlertSuccess('purchase_date_success_message');
      this.setState({ editMode: false });
      // eslint-disable-next-line no-empty
    } catch {}
  }

  enterEditMode = () => {
    this.setState({ editMode: true });
  };

  get editAction() {
    return {
      id: 'EDIT',
      icon: 'edit',
      label: 'general.edit',
      onClick: this.enterEditMode
    };
  }

  handleDateChange = (value) => {
    this.setState({ information: value }, this.updatePurchaseDate);
  };

  renderInput() {
    const { information } = this.state;

    return (
      <DatePicker
        date={information}
        showClearDate={false}
        onDateChange={this.handleDateChange}
        isOutsideRange={() => false}
      />
    );
  }

  formatInformation() {
    const { useInput } = this.props;
    const { information } = this.state;

    return useInput
      ? DateHelper.formatDate(information, shortFormatDate)
      : information;
  }

  renderInformation() {
    const { editMode } = this.state;

    if (editMode) {
      return this.renderInput();
    }

    return (
      <div className="detail__board__information">
        {this.formatInformation()}
      </div>
    );
  }

  renderActionsDropdown() {
    const { editMode } = this.state;
    const { useInput, actions } = this.props;
    const allActions = useInput ? actions.concat(this.editAction) : actions;
    const hasActions = allActions.length > 0;
    const shouldRenderAction = !editMode && hasActions;

    return (
      shouldRenderAction && (
        <Dropdown
          className="user__actions__dropdown"
          classNameMenu="user__actions__dropdown__menu"
          classNameToggle="user__actions__dropdown__toggle"
        >
          {allActions.map((action) => (
            <DropdownItem key={action.id}>
              <ButtonIcon
                onClick={action.onClick}
                id={action.id}
                icon={action.icon}
                size="small"
                transparent
              >
                <I18n label={action.label || ''} />
              </ButtonIcon>
            </DropdownItem>
          ))}
        </Dropdown>
      )
    );
  }

  render() {
    const { information } = this.state;
    const { title } = this.props;
    const isInformationLargerThanContainer =
      information?.length > MAX_INFORMATION_LENGTH;

    return (
      <div className="detail__board">
        <div className="detail__board__data">
          <div className="detail__board__title">
            <I18n html label={title} />
          </div>
          {isInformationLargerThanContainer ? (
            <InfoTooltip
              rerenderPosition={true}
              disableTranslate={true}
              text={information}
              position="center"
              className="detail__board_tooltip"
            >
              {this.renderInformation()}
            </InfoTooltip>
          ) : (
            this.renderInformation()
          )}
        </div>

        {this.renderActionsDropdown()}
      </div>
    );
  }
}
